export default __webpack_public_path__ + "static/Slider-5ef38e8d5eb258b42913b9c0bdc4f760.svg";